module.exports = __webpack_public_path__ + "static/media/al.77985873.svg";